module.exports = __webpack_public_path__ + "img/bettermynd-logo-small.ef2f2f11.png";